import React from "react";

import { Box, Stack, Typography } from "@mui/material";

import { EnterpriseWorkspaceUser } from "@app/common/workspaces/types";

import Avatar from "@rui/Avatar";

const WorkspaceMemberAutocompleteOption = ({
  user,
  ...autocompleteProps
}: {
  user: EnterpriseWorkspaceUser;
}) => {
  const displayName = user.fullName ?? user.email;

  return (
    <Box
      {...autocompleteProps}
      sx={{
        m: 1,
        p: 1,
        borderRadius: "8px",
        bgcolor: "#fff",
        "&:first-of-type": { mt: 0 },
        "&:last-child": { mb: 0 },
      }}
    >
      <Stack
        direction="row"
        sx={{ width: "100%", height: "28px" }}
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack direction="row" alignItems="center">
          {user.initials && (
            <Avatar
              name={displayName}
              sx={{
                height: "28px",
                width: "28px",
              }}
            >
              {user.initials}
            </Avatar>
          )}
          <Typography
            variant="bodyPrimaryReg"
            sx={{
              color: "shades.neutral.800",
              pl: 1,
              maxWidth: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {displayName}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default WorkspaceMemberAutocompleteOption;
